const writtenDigits = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
  'eleven',
  'twelve',
  'thirteen',
  'fourteen',
  'fifteen',
  'sixteen',
  'seventeen',
  'eighteen',
  'nineteen',
  'twenty',
  'hundred',
  'thousand',
  'million',
  'dozen',
  'thirty',
  'forty',
  'fifty',
  'sixty',
  'seventy',
  'eighty',
  'ninety',
  'once',
  'twice',
  'first',
  'second',
  'third',
  'fifth',
  'eighth',
  'ninth',
]

const anyDigit = writtenDigits.join('|')

export const removeDigits = (text: string) => {
  const regexp = new RegExp(`(\\b)(${anyDigit})(\\b)`, 'gi')
  return text
    .replace(/\d+/g, '#')
    .replace(regexp, '#')
    .replace(/( )?(#( +)?)+( )?/g, '$1#$3')
}
